import API from "@/api/lib/api";

export const getAllCategories = async (restaurant_id, menu_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/categories/${menu_id}`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleCategoryById = async (id) => {
  try {
    const response = await API.get(`restaurant/categories/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createCategory = async (data) => {
  try {
    const response = await API.post(`restaurant/categories`, data);
    return response.data;
  } catch (error) {
    console.log(error)
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateCategory = async (id, data) => {
  try {
    const response = await API.put(`restaurant/categories/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await API.delete(`restaurant/categories/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
